import balance from "assets/reports/balance.svg";
import profit_and_debts from "assets/reports/profit_and_debts.svg";
import fund from "assets/reports/fund.svg";
import notebook from "assets/reports/notebook.svg";
import account_list from "assets/reports/account_list.svg";
import hammer from "assets/reports/hammer.svg";
import account_review from "assets/reports/account_review.svg";
import creditors_and_debtors from "assets/reports/creditors_and_debtors.svg";
import personAccounting from "assets/reports/personAccounting.svg";
import debtors from "assets/reports/debtors.svg";
import productAccounting from "assets/reports/productAccounting.svg";
import sale_by_product from "assets/reports/sale_by_product.svg";
import buy_by_product from "assets/reports/buy_by_product.svg";
import tax_list from "assets/reports/tax_list.svg";
import checkout_income from "assets/reports/checkout_income.svg";
import profitGoods from "assets/reports/profit.png";
import checkout_by_person from "assets/reports/checkout_by_person.svg";
import turnover from "assets/reports/turnover.svg";
import calendar from "assets/reports/calendar.png";
import chest_turnover from "assets/reports/chest_turnover.svg";
import slanderer_turnover from "assets/reports/slanderer_turnover.svg";
import projectAccounting from "assets/reports/projectAccounting.svg";
import branchAccounting from "assets/reports/branchAccounting.svg";
import userLog from "assets/reports/userLog.svg";

const reportItems = [
  {
    title: "مالی",
    key: "financials",
    subItems: [
      {
        avatar: balance,
        title: "تراز نامه",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/BalanceSheet",
        key: "BalanceSheet",
      },
      {
        avatar: profit_and_debts,
        title: "صورت سود و زیان",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/BillProfitLoss",
        key: "BillProfitLoss",
      },
      {
        avatar: fund,
        title: "صورت حساب سرمایه",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/Capital",
        key: "Capital",
      },
    ],
  },
  {
    title: "حسابداری",
    key: "accounting",
    subItems: [
      {
        avatar: notebook,
        title: "دفتر روزنامه",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/Journal",
        key: "Journal",
      },
      {
        avatar: account_list,
        title: "دفتر حساب ها",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/transactions",
        key: "transactions",
      },
      {
        avatar: hammer,
        title: "تراز آزمایشی",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/trialBalance",
        key: "trialBalance",
      },
      {
        avatar: account_review,
        title: "مرور حساب ها",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/reviewAccounts",
        key: "reviewAccounts",
      },
    ],
  },
  {
    title: "اشخاص",
    key: "people",
    subItems: [
      {
        avatar: creditors_and_debtors,
        title: "بدهکاران و بستانکاران",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/debtorsCreditors",
        key: "debtorsCreditors",
      },
      {
        avatar: personAccounting,
        title: "کارت حساب اشخاص",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/personalAccountCard",
        key: "personalAccountCard",
      },
      {
        avatar: personAccounting,
        title: "گزارش حقوق",
        description: "گزارش حقوق به تفکیک شخص",
        url: "/reports/salaryReport",
        key: "salaryReport",
      },

    ],
  },
  {
    title: "کالا ها و خدمات",
    key: "services",
    subItems: [
      {
        avatar: productAccounting,
        title: "کارت حساب کالا",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/productsAccountCard",
        key: "productsAccountCard",
      },
    ],
  },
  // {
  //   title: "کاربران",
  //   key: "users",
  //   subItems: [
  //     {
  //       avatar: userLog,
  //       title: "کارت فعالیت کاربران",
  //       description: "",
  //       url: "/reports/userAccountCard",
  //       key: "userAccountCard",
  //     },
  //   ],
  // },
  {
    title: "خرید و فروش",
    key: "buy",
    subItems: [
      {
        avatar: sale_by_product,
        title: "فروش به تفکیک کالا",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/saleByProducts",
        key: "saleByProducts",
      },
      {
        avatar: buy_by_product,
        title: "خرید به تفکیک کالا",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/buyByProducts",
        key: "buyByProducts",
      },
      {
        avatar: buy_by_product,
        title: "فروش به تفکیک فاکتور",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/salesByFactor",
        key: "salesByFactor",
      },
      {
        avatar: debtors,
        title: "خرید به تفکیک فاکتور",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/buysByFactor",
        key: "buysByFactor",
      },
      {
        avatar: tax_list,
        title: "گزارش مالیات",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/taxReport",
        key: "taxReport",
      },
      {
        avatar: checkout_income,
        title: "سود فاکتور",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/factorProfit",
        key: "factorProfit",
      },
      {
        avatar: checkout_by_person,
        title: "خلاصه فاکتور به تفکیک شخص",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/factorSummary",
        key: "factorSummary",
      },
      {
        avatar: profitGoods,
        title: "سود و زیان کالا",
        description: "سود و زیان کالا",
        url: "/reports/ProductProfit",
        key: "factorSummary",
      },
      // {
      //     avatar: sell_by_seller,
      //     title: 'فروش به تفکیک فروشنده',
      //     description: 'خلاصه فاکتور به تفکیک شخصی'
      // },
    ],
  },
  {
    title: "بانکداری",
    key: "banking",
    subItems: [
      {
        avatar: turnover,
        title: "گردش حساب بانک",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/bankTransactions",
        key: "bankTransactions",
      },
      {
        avatar: chest_turnover,
        title: "گردش حساب صندوق",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/cashierTransactions",
        key: "cashierTransactions",
      },
      {
        avatar: slanderer_turnover,
        title: "گردش حساب تنخواه گردان",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/fundTransactions",
        key: "cashierTransactions",
      },
    ],
  },
  {
    title: "اقساط",
    key: "intallments",
    subItems: [
      {
        avatar: calendar,
        title: "گزارش اقساط",
        description: "گزارش اقساط",
        url: "/reports/installments",
        key: "intallments",
      },
     
    ],
  },
  {
    title: "سایر",
    key: "others",
    subItems: [
      {
        avatar: projectAccounting,
        title: "کارت حساب پروژه",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/projectsAccountCard",
        key: "projectsAccountCard",
      },
      {
        avatar: branchAccounting,
        title: "کارت حساب شعبه",
        description: "خلاصه فاکتور به تفکیک شخصی",
        url: "/reports/branchesAccountCard",
        key: "branchesAccountCard",
      },
      // {
      //     avatar: debtors,
      //     title: 'کارت پروژه',
      //     description: 'خلاصه فاکتور به تفکیک شخصی'
      // },
      // {
      //   avatar: userLog,
      //   title: "کارت فعالیت کاربران",
      //   description: "خلاصه فاکتور به تفکیک شخصی",
      //   url: "/reports/userLog",
      //   key: "userLog",
      // },
      {
        avatar: userLog,
        title: "کارت فعالیت کاربران",
        description: "",
        url: "/reports/userAccountCard",
        key: "userAccountCard",
      },
    ],
  },
];

export default reportItems;
